import { createSelector } from 'reselect';
import { MIN_SEGMENTS_NUMBER } from './reducers';
import { defaultConfig, useConfig } from '../../../context';
const getSegmentsState = (state) => state.segments;
export const isMultiCity = createSelector(getSegmentsState, state => state.isMultiCity);
export const getSimpleRouteSegment = createSelector(getSegmentsState, state => state.simpleRouteSegment);
export const getMultiCitySegments = createSelector(getSegmentsState, state => state.multiCitySegments);
export const canAddSegment = createSelector(isMultiCity, getMultiCitySegments, (isMultiCity, segments) => {
    var _a, _b, _c;
    const maxComplexRouteSegments = (_c = (_b = (_a = window.__webskyEngineConfig) === null || _a === void 0 ? void 0 : _a.SearchForm) === null || _b === void 0 ? void 0 : _b.maxComplexRouteSegments) !== null && _c !== void 0 ? _c : defaultConfig.SearchForm.maxComplexRouteSegments;
    return isMultiCity && segments.length < maxComplexRouteSegments;
});
export const canRemoveSegment = createSelector(isMultiCity, getMultiCitySegments, (isMultiCity, segments) => isMultiCity && segments.length > MIN_SEGMENTS_NUMBER);
export const getSegments = createSelector(isMultiCity, getSimpleRouteSegment, getMultiCitySegments, (isMultiCity, simpleRouteSegments, multiCitySegments) => (isMultiCity ? multiCitySegments : [simpleRouteSegments]));
export const makeGetSegment = (index) => {
    return createSelector(getSegments, segments => segments[index]);
};
export const getSelectedDates = createSelector(isMultiCity, getSimpleRouteSegment, getMultiCitySegments, (isMultiCity, simpleRouteSegments, multiCitySegments) => {
    const result = [];
    if (isMultiCity) {
        multiCitySegments.forEach(segment => {
            if (segment.date) {
                result.push(segment.date);
            }
        });
    }
    else {
        const segment = simpleRouteSegments;
        if (segment.date || segment.dateBack) {
            result.push(segment.date || null);
            result.push(segment.dateBack || null);
        }
    }
    return result;
});
export const getIsSegmentsInternational = createSelector(useConfig, getSegments, (config, segments) => config.global.companyInfo.iataCode === 'DV' &&
    segments.some(({ departure, arrival }) => {
        var _a, _b;
        if (departure && arrival) {
            return ((_a = departure.country) === null || _a === void 0 ? void 0 : _a.name) !== ((_b = arrival.country) === null || _b === void 0 ? void 0 : _b.name);
        }
        return false;
    }));
